var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("template", { slot: "header" }, [
        _c(
          "span",
          { staticStyle: { "font-size": "18px", "font-weight": "600" } },
          [_vm._v("QC 质检工作台")]
        ),
        _c(
          "div",
          { staticStyle: { float: "right" } },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "success",
                  size: "small",
                  icon: "el-icon-check",
                  loading: _vm.batchPassing,
                  disabled: !_vm.passableSelected.length
                },
                on: { click: _vm.handleBatchPass }
              },
              [
                _vm._v(" 批量通过"),
                _vm.passableSelected.length
                  ? _c("span", [
                      _vm._v("（" + _vm._s(_vm.passableSelected.length) + "）")
                    ])
                  : _vm._e()
              ]
            ),
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  icon: "el-icon-refresh",
                  loading: _vm.loading
                },
                on: { click: _vm.loadData }
              },
              [_vm._v("刷新")]
            )
          ],
          1
        )
      ]),
      _c("audio", {
        ref: "qcAudioPlayer",
        staticStyle: { display: "none" },
        attrs: { preload: "none" },
        on: {
          play: _vm.onAudioPlay,
          ended: _vm.onAudioEnded,
          error: _vm.onAudioError
        }
      }),
      _c(
        "el-card",
        {
          staticStyle: { "margin-bottom": "15px" },
          attrs: { shadow: "never" }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        placeholder: "搜索题面/选项/答案",
                        clearable: ""
                      },
                      on: { clear: _vm.handleSearch },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleSearch($event)
                        }
                      },
                      model: {
                        value: _vm.query.keyword,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "keyword", $$v)
                        },
                        expression: "query.keyword"
                      }
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.handleSearch },
                        slot: "append"
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "题型", clearable: "" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.questionTypeId,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "questionTypeId", $$v)
                        },
                        expression: "query.questionTypeId"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "单选", value: 1 } }),
                      _c("el-option", { attrs: { label: "连线", value: 2 } }),
                      _c("el-option", { attrs: { label: "排序", value: 3 } }),
                      _c("el-option", { attrs: { label: "简答", value: 4 } }),
                      _c("el-option", { attrs: { label: "长文本", value: 5 } }),
                      _c("el-option", { attrs: { label: "多选", value: 6 } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "技能维度", clearable: "" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.skillDimension,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "skillDimension", $$v)
                        },
                        expression: "query.skillDimension"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "听力", value: "listening" }
                      }),
                      _c("el-option", {
                        attrs: { label: "阅读", value: "reading" }
                      }),
                      _c("el-option", {
                        attrs: { label: "看", value: "viewing" }
                      }),
                      _c("el-option", {
                        attrs: { label: "写作", value: "writing" }
                      }),
                      _c("el-option", {
                        attrs: { label: "综合", value: "comprehensive" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "质检结论", clearable: "" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.qcStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "qcStatus", $$v)
                        },
                        expression: "query.qcStatus"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "待检", value: "pending" }
                      }),
                      _c("el-option", {
                        attrs: { label: "通过", value: "pass" }
                      }),
                      _c("el-option", {
                        attrs: { label: "驳回", value: "fail" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "规则旗标", clearable: "" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.flag,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "flag", $$v)
                        },
                        expression: "query.flag"
                      }
                    },
                    _vm._l(_vm.flagMetas, function(f) {
                      return _c("el-option", {
                        key: f.code,
                        attrs: { label: f.code + " " + f.label, value: f.code }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "年级", clearable: "" },
                      on: { change: _vm.handleGradeChange },
                      model: {
                        value: _vm.query.grade,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "grade", $$v)
                        },
                        expression: "query.grade"
                      }
                    },
                    _vm._l(_vm.gradeOptions, function(g) {
                      return _c("el-option", {
                        key: g.value,
                        attrs: { label: g.label, value: g.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" }, attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "册别", clearable: "" },
                      on: { change: _vm.handleBookChange },
                      model: {
                        value: _vm.query.book,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "book", $$v)
                        },
                        expression: "query.book"
                      }
                    },
                    _vm._l(_vm.bookOptions, function(b) {
                      return _c("el-option", {
                        key: b.value,
                        attrs: { label: b.label, value: b.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "单元",
                        clearable: "",
                        filterable: ""
                      },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.unit,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "unit", $$v)
                        },
                        expression: "query.unit"
                      }
                    },
                    _vm._l(_vm.unitFilterOptions, function(u) {
                      return _c("el-option", {
                        key: u.code,
                        attrs: { label: u.name, value: u.code }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.query.onlyFlagged,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "onlyFlagged", $$v)
                        },
                        expression: "query.onlyFlagged"
                      }
                    },
                    [_vm._v("只看带旗标")]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      min: 1,
                      controls: false,
                      placeholder: "题目ID",
                      clearable: ""
                    },
                    on: { change: _vm.handleSearch },
                    model: {
                      value: _vm.query.id,
                      callback: function($$v) {
                        _vm.$set(_vm.query, "id", $$v)
                      },
                      expression: "query.id"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 7 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleSearch }
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.handleResetFilter }
                    },
                    [_vm._v("重置")]
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "10px",
                        color: "#909399",
                        "font-size": "12px"
                      }
                    },
                    [_vm._v("快捷键：J/K 切换题目 · R 刷新")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "15px" }, attrs: { gutter: 15 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-num" }, [
                    _vm._v(_vm._s(_vm.stats.total))
                  ]),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("题库总数")])
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-num",
                      staticStyle: { color: "#E6A23C" }
                    },
                    [_vm._v(_vm._s(_vm.stats.pending))]
                  ),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("待检")])
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-num",
                      staticStyle: { color: "#67C23A" }
                    },
                    [_vm._v(_vm._s(_vm.stats.pass))]
                  ),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("已通过")])
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-num",
                      staticStyle: { color: "#F56C6C" }
                    },
                    [_vm._v(_vm._s(_vm.stats.fail))]
                  ),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("已驳回")])
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-num",
                      staticStyle: { color: "#F56C6C" }
                    },
                    [_vm._v(_vm._s(_vm.stats.flagged))]
                  ),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("旗标命中")])
                ]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "stat-num",
                      staticStyle: { "font-size": "18px", "padding-top": "8px" }
                    },
                    [
                      _vm._l(_vm.stats.flagCounts, function(cnt, code) {
                        return _c(
                          "el-tag",
                          {
                            key: code,
                            staticStyle: { margin: "2px" },
                            attrs: {
                              size: "small",
                              type: _vm.flagTagType(code)
                            }
                          },
                          [_vm._v(" " + _vm._s(code) + " " + _vm._s(cnt) + " ")]
                        )
                      }),
                      !_vm.stats.flagged
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#909399",
                                "font-size": "12px"
                              }
                            },
                            [_vm._v("无旗标命中")]
                          )
                        : _vm._e()
                    ],
                    2
                  ),
                  _c("div", { staticClass: "stat-label" }, [_vm._v("旗标分布")])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          !_vm.loading && !_vm.cards.length
            ? _c(
                "el-alert",
                {
                  staticStyle: { "margin-bottom": "15px" },
                  attrs: {
                    type: "info",
                    closable: false,
                    title: "当前筛选条件下没有题目",
                    "show-icon": ""
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text", size: "small" },
                      on: { click: _vm.handleResetFilter }
                    },
                    [_vm._v("清空筛选条件")]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            _vm._l(_vm.cards, function(card) {
              return _c(
                "el-col",
                {
                  key: card.id,
                  staticStyle: { "margin-bottom": "15px" },
                  attrs: { xs: 24, sm: 24, md: 12, lg: 8 }
                },
                [
                  _c(
                    "el-card",
                    {
                      staticClass: "qc-card",
                      class: _vm.cardClass(card),
                      attrs: {
                        shadow: "hover",
                        "body-style": { padding: "12px 14px" }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "qc-head" },
                        [
                          _c("el-checkbox", {
                            staticClass: "qc-select",
                            attrs: {
                              disabled: _vm.hasFlag(card),
                              value: _vm.selectedIds.includes(card.id)
                            },
                            on: {
                              change: function(val) {
                                return _vm.toggleSelect(card.id, val)
                              }
                            }
                          }),
                          _c("span", { staticClass: "qc-id" }, [
                            _vm._v("#" + _vm._s(card.id))
                          ]),
                          _c(
                            "el-tag",
                            { attrs: { size: "mini", type: "info" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.questionTypeLabel(card.questionTypeId)
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "mini",
                                type: _vm.strategyTagType(card.scoringStrategy)
                              }
                            },
                            [_vm._v(_vm._s(card.scoringStrategy || "未设策略"))]
                          ),
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "mini",
                                type: _vm.dimensionTagType(card.skillDimension)
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.dimensionLabel(card.skillDimension))
                              )
                            ]
                          ),
                          _c(
                            "el-tag",
                            { attrs: { size: "mini", type: "warning" } },
                            [_vm._v(_vm._s(_vm.bloomLabel(card.bloomLevel)))]
                          ),
                          _c("el-tag", { attrs: { size: "mini" } }, [
                            _vm._v(_vm._s(card.difficulty || "N/A"))
                          ]),
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "mini",
                                type: _vm.statusTagType(card.status)
                              }
                            },
                            [_vm._v(_vm._s(_vm.statusLabel(card.status)))]
                          ),
                          _c(
                            "span",
                            { staticClass: "qc-flags" },
                            _vm._l(card.flagDetails, function(f) {
                              return _c(
                                "el-tooltip",
                                {
                                  key: f.code,
                                  attrs: {
                                    content: f.desc + "｜建议：" + f.advice,
                                    placement: "top"
                                  }
                                },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      staticStyle: { "margin-left": "4px" },
                                      attrs: {
                                        size: "mini",
                                        type: _vm.flagTagType(f.code)
                                      }
                                    },
                                    [_vm._v(_vm._s(f.code))]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c("div", { staticClass: "qc-section" }, [
                        card.title
                          ? _c("div", { staticClass: "qc-title" }, [
                              _vm._v(_vm._s(card.title))
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "qc-question" }, [
                          _vm._v(_vm._s(card.question || "（无题干）"))
                        ]),
                        card.content
                          ? _c("div", { staticClass: "qc-content" }, [
                              _vm._v(_vm._s(card.content))
                            ])
                          : _vm._e()
                      ]),
                      card.choices && card.choices.length
                        ? _c("div", { staticClass: "qc-section" }, [
                            _c("div", { staticClass: "qc-section-label" }, [
                              _vm._v("选项")
                            ]),
                            _c(
                              "div",
                              { staticClass: "qc-choices" },
                              _vm._l(card.choices, function(opt, oi) {
                                return _c(
                                  "div",
                                  {
                                    key: oi,
                                    staticClass: "qc-choice",
                                    class: {
                                      "qc-choice--correct": _vm.isCorrectOption(
                                        card,
                                        oi
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "qc-choice-letter" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.optionLetter(card, oi))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "qc-choice-text" },
                                      [_vm._v(_vm._s(opt))]
                                    ),
                                    _vm.isCorrectOption(card, oi)
                                      ? _c(
                                          "span",
                                          { staticClass: "qc-choice-mark" },
                                          [_vm._v("✓ 正确")]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "qc-section" }, [
                        _c("div", { staticClass: "qc-section-label" }, [
                          _vm._v("正确答案")
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "qc-answer",
                            class: {
                              "qc-answer--bad": !card.answerIsLetterSequence
                            }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(card.correctAnswer || "（空）") + " "
                            ),
                            !card.answerIsLetterSequence
                              ? _c("span", { staticClass: "qc-answer-warn" }, [
                                  _vm._v("（非字母序列）")
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      card.explanation
                        ? _c("div", { staticClass: "qc-section" }, [
                            _c("div", { staticClass: "qc-section-label" }, [
                              _vm._v("解析")
                            ]),
                            _c("div", { staticClass: "qc-explanation" }, [
                              _vm._v(_vm._s(card.explanation))
                            ])
                          ])
                        : _vm._e(),
                      card.pic || card.audio
                        ? _c("div", { staticClass: "qc-section" }, [
                            _c("div", { staticClass: "qc-section-label" }, [
                              _vm._v("素材")
                            ]),
                            card.pic
                              ? _c("div", { staticClass: "qc-pic" }, [
                                  _c("img", {
                                    attrs: { src: card.pic, alt: "配图" },
                                    on: {
                                      click: function($event) {
                                        return _vm.previewPic(card.pic)
                                      }
                                    }
                                  })
                                ])
                              : _vm._e(),
                            card.audio
                              ? _c("div", { staticClass: "qc-audio" }, [
                                  _c(
                                    "div",
                                    { staticClass: "qc-audio-file" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "qc-audio-name" },
                                        [
                                          _vm._v(
                                            "🎧 " +
                                              _vm._s(
                                                _vm.audioFileName(card.audio)
                                              )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "qc-audio-play",
                                          attrs: {
                                            type: "text",
                                            size: "mini",
                                            icon: _vm.isPlaying(card.id)
                                              ? "el-icon-video-pause"
                                              : "el-icon-video-play",
                                            "data-question-id": card.id
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleAudio(card)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.isPlaying(card.id)
                                                ? "暂停"
                                                : "播放"
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  card.audioTextMissing
                                    ? _c(
                                        "div",
                                        { staticClass: "qc-audio-missing" },
                                        [
                                          _vm._v(
                                            "⚠️ 缺少音频对照文本，无法核验音频内容"
                                          )
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "qc-audio-text" },
                                        [_vm._v(_vm._s(card.audioText))]
                                      )
                                ])
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "qc-section" }, [
                        _c("div", { staticClass: "qc-section-label" }, [
                          _vm._v("知识点绑定")
                        ]),
                        card.bindings && card.bindings.length
                          ? _c(
                              "div",
                              { staticClass: "qc-bindings" },
                              [
                                _vm._l(card.bindings, function(b) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: b.nodeId,
                                      staticStyle: { margin: "0 4px 4px 0" },
                                      attrs: {
                                        size: "mini",
                                        type:
                                          b.bindType === "primary"
                                            ? "primary"
                                            : "warning"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(b.nodeName || b.nodeId) +
                                          " "
                                      ),
                                      _c(
                                        "span",
                                        { staticStyle: { opacity: "0.65" } },
                                        [_vm._v(" · " + _vm._s(b.nodeId))]
                                      ),
                                      _vm.nodeScopeText(b)
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: { opacity: "0.65" }
                                            },
                                            [
                                              _vm._v(
                                                " · " +
                                                  _vm._s(_vm.nodeScopeText(b))
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        { staticStyle: { opacity: "0.7" } },
                                        [
                                          _vm._v(
                                            "（" +
                                              _vm._s(
                                                b.bindType === "primary"
                                                  ? "主绑"
                                                  : "跨绑"
                                              ) +
                                              "）"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                card.crossBindCount > 2
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: { size: "mini", type: "danger" }
                                      },
                                      [_vm._v("跨绑过多，需复核归属")]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          : _c("span", { staticClass: "qc-muted" }, [
                              _vm._v("未绑定知识点")
                            ])
                      ]),
                      _c(
                        "div",
                        { staticClass: "qc-footer" },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "small",
                                type: _vm.qcStatusTagType(card.qcStatus)
                              }
                            },
                            [_vm._v(_vm._s(_vm.qcStatusLabel(card.qcStatus)))]
                          ),
                          card.rejectReasonCodes &&
                          card.rejectReasonCodes.length
                            ? _c("span", { staticClass: "qc-reject-reasons" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.rejectReasonLabel(
                                        card.rejectReasonCodes
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            : _vm._e(),
                          _c(
                            "span",
                            { staticClass: "qc-footer-right" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "text",
                                    size: "mini",
                                    icon: "el-icon-edit"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleEdit(card)
                                    }
                                  }
                                },
                                [_vm._v("编辑")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#F56C6C" },
                                  attrs: {
                                    type: "text",
                                    size: "mini",
                                    icon: "el-icon-close"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.openReject(card)
                                    }
                                  }
                                },
                                [_vm._v("驳回")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#67C23A" },
                                  attrs: {
                                    type: "text",
                                    size: "mini",
                                    icon: "el-icon-check"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handlePass(card)
                                    }
                                  }
                                },
                                [_vm._v("通过（上架）")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            }),
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "10px", "text-align": "right" },
            attrs: {
              background: "",
              "current-page": _vm.pagination.current,
              "page-size": _vm.pagination.size,
              total: _vm.pagination.total,
              "page-sizes": [12, 24, 48],
              layout: "total, sizes, prev, pager, next, jumper"
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "驳回题目",
            visible: _vm.rejectDialog.visible,
            width: "560px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.rejectDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "8px",
                color: "#606266",
                "font-size": "13px"
              }
            },
            [
              _vm._v(" 题目 "),
              _c("b", [
                _vm._v(
                  "#" +
                    _vm._s(
                      _vm.rejectDialog.question
                        ? _vm.rejectDialog.question.id
                        : ""
                    )
                )
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.rejectDialog.question
                      ? _vm.rejectDialog.question.question
                      : ""
                  ) +
                  " "
              )
            ]
          ),
          _c("el-alert", {
            staticStyle: { "margin-bottom": "12px" },
            attrs: {
              type: "warning",
              closable: false,
              "show-icon": "",
              title:
                "驳回后题目将被置为草稿（draft）下架，不会被物理删除，教研复核后再次「通过」即恢复上架。"
            }
          }),
          _c("div", { staticClass: "qc-dialog-label" }, [
            _vm._v("驳回原因（可多选，至少一项）")
          ]),
          _c(
            "el-checkbox-group",
            {
              staticClass: "qc-reason-group",
              model: {
                value: _vm.rejectDialog.reasons,
                callback: function($$v) {
                  _vm.$set(_vm.rejectDialog, "reasons", $$v)
                },
                expression: "rejectDialog.reasons"
              }
            },
            _vm._l(_vm.rejectReasons, function(r) {
              return _c(
                "el-checkbox",
                {
                  key: r.code,
                  staticClass: "qc-reason-item",
                  attrs: { label: r.code, border: "", size: "small" }
                },
                [_vm._v(" " + _vm._s(r.label) + " ")]
              )
            }),
            1
          ),
          _c(
            "div",
            {
              staticClass: "qc-dialog-label",
              staticStyle: { "margin-top": "14px" }
            },
            [_vm._v("驳回备注（必填，不少于 5 字）")]
          ),
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 3,
              maxlength: "200",
              "show-word-limit": "",
              placeholder: "请说明问题所在与修改建议"
            },
            model: {
              value: _vm.rejectDialog.note,
              callback: function($$v) {
                _vm.$set(_vm.rejectDialog, "note", $$v)
              },
              expression: "rejectDialog.note"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.rejectDialog.visible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", loading: _vm.rejectDialog.saving },
                  on: { click: _vm.submitReject }
                },
                [_vm._v("确认驳回")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "该题命中规则旗标",
            visible: _vm.flagConfirm.visible,
            width: "520px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.flagConfirm, "visible", $event)
            }
          }
        },
        [
          _c("el-alert", {
            staticStyle: { "margin-bottom": "12px" },
            attrs: {
              type: "warning",
              closable: false,
              "show-icon": "",
              title: "带旗标的题目通过需二次确认，请先确认旗标问题已处理。"
            }
          }),
          _vm._l(_vm.flagConfirm.flags, function(f) {
            return _c(
              "div",
              { key: f.code, staticClass: "qc-flag-line" },
              [
                _c(
                  "el-tag",
                  { attrs: { size: "mini", type: _vm.flagTagType(f.code) } },
                  [_vm._v(_vm._s(f.code))]
                ),
                _c("b", [_vm._v(_vm._s(f.label))]),
                _vm._v("：" + _vm._s(f.desc) + " ")
              ],
              1
            )
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.flagConfirm.visible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmPassWithFlag }
                },
                [_vm._v("确认通过")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }